module.exports = __webpack_public_path__ + "static/media/unreviwed-status.088c2809.svg";